// extracted by mini-css-extract-plugin
module.exports = {"ProductRecommendations":"styles_ProductRecommendations__PtXWQ","title":"styles_title__c0mIk","sliderContainer":"styles_sliderContainer__fzUJ3","slider":"styles_slider__weDeI"};